/* Source: /home/sidsolaiyappan/skooch_ai/shared/toast_prompt.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useStoreSlice, getStoreToastVisible, subscribeStoreToastVisible, setStoreToastVisible, getStoreToastResponse, subscribeStoreToastResponse, setStoreToastResponse, getStoreToastMCQOptions, subscribeStoreToastMCQOptions, setStoreToastMCQOptions, getStoreToastDimension, subscribeStoreToastDimension, getStoreToastTargetEntityId, subscribeStoreToastTargetEntityId, getStoreToastTargetSlot, subscribeStoreToastTargetSlot, getStoreToastFamiliarity, subscribeStoreToastFamiliarity, getStoreToastQuestionId, subscribeStoreToastQuestionId, getStoreToastQuestionType, subscribeStoreToastQuestionType, getStoreToastWhyLine, subscribeStoreToastWhyLine, getStoreToastCategory, subscribeStoreToastCategory, getStoreToastPlannedMins, subscribeStoreToastPlannedMins, setStoreLearningTick } from "./store.js";
import { logInteractionEvent } from "./event_capture.js";
import { applyFocusPeakConsent } from "./learning_handlers.js";
import { dominantBucket } from "./active_learning.js";
function ToastPrompt(props) {
  let toastVisible = useStoreSlice(getStoreToastVisible, subscribeStoreToastVisible);
  let toastResponse = useStoreSlice(getStoreToastResponse, subscribeStoreToastResponse);
  let toastMCQOptions = useStoreSlice(getStoreToastMCQOptions, subscribeStoreToastMCQOptions);
  let toastDimension = useStoreSlice(getStoreToastDimension, subscribeStoreToastDimension);
  let toastTargetEntityId = useStoreSlice(getStoreToastTargetEntityId, subscribeStoreToastTargetEntityId);
  let toastTargetSlot = useStoreSlice(getStoreToastTargetSlot, subscribeStoreToastTargetSlot);
  let toastFamiliarity = useStoreSlice(getStoreToastFamiliarity, subscribeStoreToastFamiliarity);
  let toastQuestionId = useStoreSlice(getStoreToastQuestionId, subscribeStoreToastQuestionId);
  let toastQuestionType = useStoreSlice(getStoreToastQuestionType, subscribeStoreToastQuestionType);
  let toastWhyLine = useStoreSlice(getStoreToastWhyLine, subscribeStoreToastWhyLine);
  let toastCategory = useStoreSlice(getStoreToastCategory, subscribeStoreToastCategory);
  let toastPlannedMins = useStoreSlice(getStoreToastPlannedMins, subscribeStoreToastPlannedMins);
  let _isLearning = (toastMCQOptions && (toastMCQOptions.length > 0));
  let _famPct = Math.round(((toastFamiliarity ? toastFamiliarity : 0) * 100));
  let _answerMcq = v => {
    try {
      logInteractionEvent("feedback_answer", {"entity_id": toastTargetEntityId, "slot_minutes": toastTargetSlot, "category": (toastCategory ? toastCategory : null), "payload": {"surface": "toast", "question_id": toastQuestionId, "question_type": toastQuestionType, "dimension": toastDimension, "answer": v, "direction": "", "target_entity_id": toastTargetEntityId, "target_slot": toastTargetSlot, "category": (toastCategory ? toastCategory : ""), "planned_mins": (toastPlannedMins ? toastPlannedMins : 0)}});
    } catch (__jac_e) {
      if (true) {
        let _efa = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    try {
      if (((toastQuestionType === "streak_confirm") && (v === "yes_default"))) {
        let _slotForBucket = (((toastTargetSlot !== undefined) && (toastTargetSlot !== null)) ? toastTargetSlot : 0);
        applyFocusPeakConsent(dominantBucket(_slotForBucket));
      }
    } catch (__jac_e) {
      if (true) {
        let _eac = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    try {
      setStoreLearningTick(Date.now());
    } catch (__jac_e) {
      if (true) {
        let _elt = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    setStoreToastMCQOptions([]);
    setStoreToastVisible(false);
  };
  let _dismiss = () => {
    setStoreToastMCQOptions([]);
    setStoreToastVisible(false);
  };
  let _dismissLearning = () => {
    try {
      logInteractionEvent("feedback_answer", {"entity_id": toastTargetEntityId, "slot_minutes": toastTargetSlot, "signal_weight": 0, "payload": {"surface": "toast", "question_id": toastQuestionId, "question_type": toastQuestionType, "dimension": toastDimension, "answer": "_dismissed", "direction": "", "target_entity_id": toastTargetEntityId, "target_slot": toastTargetSlot}});
    } catch (__jac_e) {
      if (true) {
        let _efd = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    try {
      setStoreLearningTick(Date.now());
    } catch (__jac_e) {
      if (true) {
        let _elt2 = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    setStoreToastMCQOptions([]);
    setStoreToastVisible(false);
  };
  let _actions = (_isLearning ? __jacJsx("div", {"className": "toast-actions"}, [toastMCQOptions.map(opt => {
    return __jacJsx("button", {"key": opt.value, "className": "btn btn-sm btn-secondary", "onClick": () => {
      _answerMcq(opt.value);
    }}, [opt.label]);
  }), __jacJsx("button", {"className": "btn btn-sm btn-ghost toast-dismiss-learning", "aria-label": "Dismiss", "title": "Dismiss", "onClick": () => {
    _dismissLearning();
  }}, ["\u2715"])]) : __jacJsx("div", {"className": "toast-actions"}, [__jacJsx("button", {"className": "btn btn-sm btn-primary", "onClick": _dismiss}, ["Sounds good"]), __jacJsx("button", {"className": "btn btn-sm btn-secondary", "onClick": _dismiss}, ["Keep it"]), __jacJsx("button", {"className": "btn btn-sm btn-ghost", "onClick": _dismiss}, ["Dismiss"])]));
  let _famBar = (_isLearning ? __jacJsx("div", {"className": "toast-familiarity"}, [__jacJsx("div", {"className": "toast-familiarity-track"}, [__jacJsx("div", {"className": "toast-familiarity-fill", "style": {"width": (String(_famPct) + "%")}}, [])]), __jacJsx("div", {"className": "toast-familiarity-caption"}, [(("Getting to know you \u2014 " + String(_famPct)) + "% \u00b7 a few quick questions now means fewer later")])]) : null);
  let _whyLineEl = (toastWhyLine ? __jacJsx("div", {"className": "toast-whyline", "style": {"fontSize": "12px", "opacity": "0.65", "marginTop": "4px", "marginLeft": "40px"}}, [toastWhyLine]) : null);
  return (toastVisible ? __jacJsx("div", {"className": "toast-container toast-container-visible"}, [__jacJsx("div", {"className": "toast-card"}, [_famBar, __jacJsx("div", {"className": "toast-header"}, [__jacJsx("div", {"className": "toast-avatar"}, ["S"]), __jacJsx("div", {"className": "toast-message"}, [toastResponse])]), _whyLineEl, _actions, __jacJsx("input", {"className": "toast-input", "type": "text", "value": toastResponse, "onChange": e => {
    setStoreToastResponse(e.target.value);
  }, "placeholder": "Or tell me what you prefer..."}, [])])]) : null);
}
export {ToastPrompt};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:ToastPrompt": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=toast_prompt.js.map
